import { Trash2 } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

function SignaturePad({ value, onChange, showClearButton = true }) {
  const canvasRef = useRef(null);
  const drawingRef = useRef(false);
  const [hasDrawn, setHasDrawn] = useState(Boolean(value));

  useEffect(() => {
    const canvas = canvasRef.current;

    if (!canvas) {
      return;
    }

    const context = canvas.getContext('2d');
    context.lineWidth = 2;
    context.lineCap = 'round';
    context.strokeStyle = '#5f5f5f';

    if (!value) {
      context.clearRect(0, 0, canvas.width, canvas.height);
      setHasDrawn(false);
      return;
    }

    const image = new Image();
    image.onload = () => {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      setHasDrawn(true);
    };
    image.src = value;
  }, [value]);

  const getPoint = (event) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();

    return {
      x: ((event.clientX - rect.left) / rect.width) * canvas.width,
      y: ((event.clientY - rect.top) / rect.height) * canvas.height,
    };
  };

  const handlePointerDown = (event) => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    const point = getPoint(event);

    drawingRef.current = true;
    context.beginPath();
    context.moveTo(point.x, point.y);
  };

  const handlePointerMove = (event) => {
    if (!drawingRef.current) {
      return;
    }

    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    const point = getPoint(event);

    context.lineTo(point.x, point.y);
    context.stroke();
  };

  const finishDrawing = () => {
    if (!drawingRef.current) {
      return;
    }

    drawingRef.current = false;
    const canvas = canvasRef.current;
    const nextValue = canvas.toDataURL('image/png');
    setHasDrawn(true);
    onChange(nextValue);
  };

  const clearSignature = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    drawingRef.current = false;
    setHasDrawn(false);
    onChange('');
  };

  return (
    <div className="space-y-3">
      <p className="font-login text-[14px] font-semibold text-[#444444]">
        Por favor firme dentro del Cuadrado
      </p>

      <div className="overflow-hidden rounded-[8px] border border-[#d7dce2] bg-white">
        <canvas
          ref={canvasRef}
          width={640}
          height={240}
          onPointerDown={handlePointerDown}
          onPointerMove={handlePointerMove}
          onPointerUp={finishDrawing}
          onPointerLeave={finishDrawing}
          className="h-[180px] w-full touch-none bg-white"
        />
      </div>

      {showClearButton ? (
        <button
          type="button"
          onClick={clearSignature}
          className="inline-flex items-center gap-2 rounded-[8px] bg-[#ff5a4d] px-3 py-2 font-login text-[14px] font-bold text-white transition hover:brightness-105 disabled:opacity-60"
          disabled={!hasDrawn}
        >
          <Trash2 className="h-4 w-4" strokeWidth={2.2} />
          Borrar
        </button>
      ) : null}
    </div>
  );
}

export default SignaturePad;
